
const digest = '33ae97b26c0735bc3e76fdbc795a6b0e996ce27b42ea80ffc7e05afb4e6fb290';
const classes = {"title":"_title_rmv1f_1","field":"_field_rmv1f_9","formWrapper":"_formWrapper_rmv1f_13"};
const css = `._title_rmv1f_1 {
  font-family: Rubik, sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin: 16px 0 !important;
}

._field_rmv1f_9 {
  margin-bottom: 16px;
}

._formWrapper_rmv1f_13 {
  display: grid;
  grid-template-columns: auto;
  grid-gap: 32px;
  margin-bottom: 16px;
}
@media (min-width: 1400px) {
  ._formWrapper_rmv1f_13 {
    grid-template-columns: auto auto;
  }
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  